export default __webpack_public_path__ + "static/media/3.44713e86.png";